import { Button } from "@/components/ui/button";
import { files } from "@/lib/admin-api";
import { DOC_TYPE_LABELS, type DocType } from "@ow/shared";
import { Upload } from "lucide-react";
import { useRef, useState } from "react";

const DOC_TYPES: DocType[] = ["cv", "assessment", "reference", "offer_letter", "other"];

export function FileUpload({ candidateId, onUploaded }: { candidateId: string; onUploaded: () => void }) {
  const inputRef = useRef<HTMLInputElement>(null);
  const [docType, setDocType] = useState<DocType>("cv");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function onPick(e: React.ChangeEvent<HTMLInputElement>) {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusy(true);
    setError(null);
    try {
      await files.upload(candidateId, file, docType);
      onUploaded();
    } catch (err) {
      setError(err instanceof Error ? err.message : "upload failed");
    } finally {
      setBusy(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  }

  return (
    <div className="flex items-center gap-2">
      <select
        value={docType}
        onChange={(e) => setDocType(e.target.value as DocType)}
        className="h-8 rounded-md border border-input bg-transparent px-2 text-sm"
      >
        {DOC_TYPES.map((t) => (
          <option key={t} value={t}>
            {DOC_TYPE_LABELS[t]}
          </option>
        ))}
      </select>
      <input ref={inputRef} type="file" accept=".pdf,.doc,.docx" hidden onChange={onPick} />
      <Button size="sm" variant="outline" disabled={busy} onClick={() => inputRef.current?.click()}>
        <Upload className="size-4" /> {busy ? "Uploading…" : "Upload"}
      </Button>
      {error ? <span className="text-xs text-[var(--color-destructive)]">{error}</span> : null}
    </div>
  );
}
